export const timeline = [
  {
    period: '2004 – 2009',
    title: 'Acheteuse industrielle',
    text: 'Premiers pas dans un grand groupe industriel : achats de composants, négociations annuelles et découverte du terrain usine.',
  },
  {
    period: '2009 – 2014',
    title: 'Responsable achats famille',
    text: 'Pilotage de catégories stratégiques, appels d’offres internationaux et premiers projets de sourcing en Europe et en Asie.',
  },
  {
    period: '2014 – 2020',
    title: 'Directrice achats & supply chain',
    text: 'Direction d’une équipe de 25 personnes, refonte de l’organisation, déploiement d’un ERP et réduction significative des stocks.',
  },
  {
    period: '2020',
    title: 'Création de L Procure Consulting',
    text: 'Lancement du cabinet pour mettre cette expérience au service des PME et ETI qui veulent professionnaliser leurs achats.',
  },
  {
    period: 'Aujourd’hui',
    title: 'Conseil & management de transition',
    text: 'Missions de transformation, diagnostics et intérims de direction achats dans une dizaine de secteurs.',
  },
];

export const values = [
  {
    title: 'Pragmatisme',
    text: 'Pas de rapport de 200 pages : des actions concrètes, priorisées selon leur impact réel sur votre marge.',
  },
  {
    title: 'Transparence',
    text: 'Des gains mesurés avec vos chiffres, une méthode expliquée, des honoraires clairs dès le départ.',
  },
  {
    title: 'Engagement sur résultats',
    text: 'Je m’engage sur des objectifs chiffrés, avec la possibilité d’indexer une partie de mes honoraires sur les gains.',
  },
  {
    title: 'Transmission',
    text: 'Chaque mission laisse des équipes plus autonomes, des outils en place et des compétences transférées.',
  },
];

export const credentials = [
  'Diplômée d’une école de commerce, spécialisation achats & logistique',
  'Certification en management de transition',
  'Pratique courante de l’anglais et de l’espagnol',
  'Expérience des ERP SAP, Oracle et Sage X3',
];
